export default "__VITE_ASSET__9fQRYkHu__"